// helper 定义通用的非业务函数降低其它函数的复杂度，业务类函数（不可在其它项目中复用）可以定义至 util.ts

// parseInt for an array
function parseIntArray (array: string[]) {
  const intArray: number[] = []
  if (array) {
    array.forEach((element, index) => {
      intArray[index] = parseInt(element)
    })
    return intArray
  } else return null
}

// judge if element 'needle' is in an array 'haystack'
function inArray <type> (needle: type, haystack: type[]) {
  const length = haystack.length
  for (let i = 0; i < length; i++) {
    if (haystack[i] === needle) return true
  }
  return false
}

const toCamel = (str: string): string => {
  return str.replace(/([_-][a-z])/gi, ($1: string) => {
    return $1.toUpperCase().replace('-', '').replace('_', '')
  })
}

const isArray = function (
  input: Record<string, unknown> | Record<string, unknown>[] | unknown
): input is Record<string, unknown>[] {
  return Array.isArray(input)
}

const isObject = function (
  obj: Record<string, unknown> | Record<string, unknown>[] | unknown
): obj is Record<string, unknown> {
  return (
    obj === Object(obj) && !Array.isArray(obj) && typeof obj !== 'function'
  )
}

const camelize = function <T> (input: T): T {
  return (function recurse<
    K extends Record<string, unknown> | Record<string, unknown>[] | unknown
  > (input: K): K {
    if (isObject(input)) {
      return Object.keys(input).reduce((acc, key) => {
        return Object.assign(acc, { [toCamel(key)]: recurse(input[key]) })
      }, {} as K)
    } else if (isArray(input)) {
      return input.map((i) => recurse(i)) as K
    }
    return input
  })(input)
}

module.exports = {
  parseIntArray,
  inArray,
  camelize
}
